import { AssociationIdData, DoctorInfoData, ClinicInfoData, ClinicPhotoData, DoctorData, SelfieData, IdData } from "../../../shared/types/models/DoctorData";
import { Result } from "../../../shared/api/services/result";

export abstract class BaseAuthService {
    abstract submitSelfie(data: SelfieData): Promise<Result<DoctorData>>;
    abstract submitId(data: IdData): Promise<Result<DoctorData>>;
    abstract getInfo(): Promise<Result<DoctorData>>;
    abstract submitAssociationId(data: AssociationIdData): Promise<Result<boolean>>;
    abstract submitDoctorInfo(data: DoctorInfoData): Promise<Result<boolean>>;
    abstract submitClinicInfo(data: ClinicInfoData): Promise<Result<boolean>>;
    abstract submitClinicPhoto(data: ClinicPhotoData): Promise<Result<boolean>>;

    protected handleError(error: any): Result<any> {
      return Result.failure(error?.toString() || 'Unknown error');
    }
  }